const KEY = "forkd_onboarding_complete";

export const onboarding = {
  isComplete(): boolean {
    try {
      return localStorage.getItem(KEY) === "true";
    } catch {
      return false;
    }
  },
  markComplete() {
    try {
      localStorage.setItem(KEY, "true");
    } catch {}
  },
  reset() {
    try {
      localStorage.removeItem(KEY);
    } catch {}
  },
};
